import AbstractRestApi from './AbstractRestApi'
import SelectApiClientType from '@/api/SelectApiClientType'

class BrandsApiClient extends AbstractRestApi {
    getBaseUrl() {
        return '/api/v1/brands'
    }

    // brand membership changes the restaurants' brandId/storeId shown in the select options
    getRelatedSelectApi() {
        return SelectApiClientType.RESTAURANT
    }
}

export default new BrandsApiClient()
